import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl, FormattedMessage } from 'react-intl';
import { formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import ImageUploadComponent from '../../../Common/ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommonImageDisplay';

import messages from '../../../../locale/messages';
import { safetyUploadDir } from '../../../../config';
import { photosShow } from '../../../../helpers/photosShow';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import bt from '../../../commonStyle.css';
import s from './SafetyImageUploader.css';

class SafetyImageUploader extends React.Component {

    success = async (file, fromServer) => {
        const { change: changeField, form, fieldName, demoRestriction: restrict } = this.props;
        const fileName = fromServer?.file?.filename;

        if (!fileName) return;

        const isRestrict = await restrict({});
        if (isRestrict) return;

        changeField(form, fieldName, photosShow(safetyUploadDir) + fileName);
    }

    clearImage = async () => {
        const { change: changeField, form, fieldName, demoRestriction: restrict } = this.props;
        const isRestrict = await restrict({});
        if (isRestrict) return;

        changeField(form, fieldName, '');
    }

    render() {
        const { image, defaultImage, label, loader, loaderName, postUrl } = this.props;
        const { formatMessage } = this.props.intl;
        const preview = image || defaultImage;
        const uploadPath = photosShow(safetyUploadDir);
        const isUploaded = image && image.indexOf(uploadPath) === 0;

        return (
            <div>
                {label && <label className={s.labelTextNew}>{label}</label>}
                <div className={cx(bt.picContainerMain, s.preview)}>
                    <div className={cx(bt.picContainer)}>
                        <CommonImageDisplay
                            loader={loader}
                            image={preview}
                            isDefaultPic={!preview}
                            isDelete={isUploaded}
                            deleteImage={this.clearImage}
                        />
                    </div>
                </div>
                <div className={cx(bt.btnPrimary, s.uploadButton, 'photoUploadBtn')}>
                    <ImageUploadComponent
                        defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
                        componentConfig={{
                            iconFiletypes: ['.jpg', '.png', '.jpeg', '.svg'],
                            multiple: false,
                            showFiletypeIcon: false,
                            postUrl,
                        }}
                        acceptedTypes={['image/jpeg', 'image/png', 'image/svg+xml']}
                        loaderName={loaderName}
                        success={this.success}
                    />
                </div>
                <p className={s.note}>
                    <FormattedMessage {...messages.safetyImageFallbackNote} />
                </p>
            </div>
        );
    }
}

const mapState = (state, ownProps) => ({
    image: ownProps.form ? formValueSelector(ownProps.form)(state, ownProps.fieldName) : '',
    loader: ownProps.loaderName ? state?.loader?.[ownProps.loaderName] : false,
});

const mapDispatch = {
    change,
    demoRestriction,
};

export default compose(
    injectIntl,
    withStyles(s, bt),
    connect(mapState, mapDispatch)
)(SafetyImageUploader);
